module.exports = __webpack_public_path__ + "img/user-nav-jrdd-icon.1391d3c2.png";